module.exports = __webpack_public_path__ + "static/index-slider-04-40c3361b2c08c8c214049ec3a5931db0.png";